import { dateFormatOptionsMap } from './dateFormatOptions';
import { getIntlDateFormatter } from './getIntlDateFormatterMap';
import { SupportedLocalizedDateTimeFormat } from './SupportedLocalizedDateTimeFormat';
import { toLocaleStringSupportsLocales } from './toLocaleStringSupportsLocales';
function getLocDateString(date, format, officeMarket) {
    var _a;
    try {
        var intlDateFormatterMap = getIntlDateFormatter(officeMarket, format);
        if (!date) {
            return undefined;
        }
        // Prefer using Intl for performance reasons.
        if (intlDateFormatterMap.has(format)) {
            return (_a = intlDateFormatterMap.get(format)) === null || _a === void 0 ? void 0 : _a.format(date);
        }
        // Fall back to toLocaleDateString if it can localize locales.
        if (toLocaleStringSupportsLocales) {
            if (format === SupportedLocalizedDateTimeFormat.Default) {
                return date.toLocaleDateString(officeMarket);
            }
            if (dateFormatOptionsMap) {
                var options = dateFormatOptionsMap.get(format);
                return date.toLocaleDateString(officeMarket, options);
            }
        }
        // As a last resort, just use the toDateString()
        return date.toDateString();
    }
    catch (error) {
        return undefined;
    }
}
// Ex: 9/3/2010
export function getLocalizedDateStringDefault(date, officeMarket) {
    return getLocDateString(date, SupportedLocalizedDateTimeFormat.Default, officeMarket);
}
// Ex: Sep 3, 2010
export function getLocalizedDateStringMedium(date, officeMarket) {
    return getLocDateString(date, SupportedLocalizedDateTimeFormat.Medium, officeMarket);
}
// Ex: Friday, September 3, 2010
export function getLocalizedDateStringLong(date, officeMarket) {
    return getLocDateString(date, SupportedLocalizedDateTimeFormat.Long, officeMarket);
}
// Ex: 3 Fri
export function getLocalizedWeekdayDate(date, officeMarket) {
    return getLocDateString(date, SupportedLocalizedDateTimeFormat.WeekdayDate, officeMarket);
}
// Ex: 3 Friday
export function getLocalizedWeekdayDateLong(date, officeMarket) {
    return getLocDateString(date, SupportedLocalizedDateTimeFormat.WeekdayDateLong, officeMarket);
}
// Ex: Sep 3
export function getLocalizedMonthDate(date, officeMarket) {
    return getLocDateString(date, SupportedLocalizedDateTimeFormat.MonthDate, officeMarket);
}
// Don't use this if supportsLocaleSpecifiers is false
// Ex: Fri
// TODO: Might need to get localized day/month names from loc service if different capitalization is needed
export function getLocalizedWeekday(date, officeMarket) {
    return getLocDateString(date, SupportedLocalizedDateTimeFormat.Weekday, officeMarket);
}
// Ex: 12:05 PM
export function getFormatTimeFromDate(date, officeMarket) {
    var _a, _b;
    try {
        var timeFormat = SupportedLocalizedDateTimeFormat.Time;
        var intlDateFormatterMap = getIntlDateFormatter(officeMarket, timeFormat);
        // Prefer using Intl for performance reasons.
        if (intlDateFormatterMap.has(timeFormat)) {
            return ((_b = (_a = intlDateFormatterMap.get(timeFormat)) === null || _a === void 0 ? void 0 : _a.format(date)) !== null && _b !== void 0 ? _b : undefined);
        }
        // Fall back to toLocaleTimeString() if it supports Locales.
        if (toLocaleStringSupportsLocales && dateFormatOptionsMap) {
            return date.toLocaleTimeString(officeMarket, dateFormatOptionsMap.get(SupportedLocalizedDateTimeFormat.Time));
        }
        // As a last resort, use Date.toTimeString()
        return date.toTimeString();
    }
    catch (_c) {
        return undefined;
    }
}
//# sourceMappingURL=getLocDateStrings.js.map